// src/pages/Privacy.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <div className="container mx-auto px-6 py-20 max-w-4xl">
        {/* Back button -> Signup */}
        <button
          onClick={() => navigate('/signup')}
          className="text-sm text-primary-600 hover:underline"
        >
          &larr; Back
        </button>

        <h1 className="text-3xl font-bold mt-6 mb-4">Privacy Policy</h1>
        <p className="text-gray-700 dark:text-gray-300 mb-6">
          This is a placeholder Privacy Policy. Replace this text with your full policy describing
          data collection, use, and user rights.
        </p>

        <section className="prose max-w-none dark:prose-invert">
          <h2>Information We Collect</h2>
          <p>Describe what data is collected (account info, usage data, etc.).</p>

          <h2>How We Use Data</h2>
          <p>Explain how the collected information is used to provide and improve the service.</p>

          <h2>Data Sharing</h2>
          <p>Describe third parties or legal obligations under which data may be shared.</p>

          <h2>Your Rights</h2>
          <p>Explain how users can access, modify, or delete their data.</p>

          <h2>Contact</h2>
          <p>
            Questions about privacy? Email us at{' '}
            <a href="mailto:privacy@yourdomain.com" className="text-primary-600 hover:underline">
              privacy@yourdomain.com
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
